module.exports = __webpack_public_path__ + "static/img/LOUIS-KELLAWAY.a2fec60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LOUIS-KELLAWAY.jpg
// module id = c7Jj
// module chunks = 0